import React from 'react';
import { Link } from 'react-router-dom';
import { store } from 'react-notifications-component';
import { Translate } from "react-localize-redux";
import validIcon from "./../../assets/images/icons/status/valid.svg";
import star from "./../../assets/images/icons/star.svg";
import mail from "./../../assets/images/icons/mail_primary.svg";
import starActive from "./../../assets/images/icons/star_active.svg"
import { invitUserAction } from '../../actions/providersActions';
import { useGlobalContext } from '../context/GlobalContext';

export default function Contacts({ contacts , companyId , daysOptions, type, ...props }) {
  const dispatch = useGlobalContext()[1];
  function renderPresenceDays(contact) {
    var days = []
    if (!daysOptions) return null;
    daysOptions.forEach(day => {
      let found = contact?.presence?.find(d => d === day.value);
      if (found) days.push(day.label)
    });
    return days.map((item ,i ) => <div key={i} className="list-item selected">{item}</div>)
  }

  async function handleInvitUser(user) {
    if (type) {
      const res = await invitUserAction(dispatch, type, user._id );
      if (res) {
        store.addNotification({
          message: "Invitation envoyée",
          type: "success",
          insert: "top",
          container: "bottom-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      }
    }
  }

  return (
    <>
      <div className="title">
        <h2><Translate id="contacts.title"/></h2>
        <Link to={"/" + props.root + "-contact-edit/" + companyId} >
          <button className="btn-edit" style={{ width : 100}} ><Translate id="btn.edit"/></button>
        </Link>
      </div>
      <div className="row contact-list">
        {contacts.map((contact,i) => {
          return (
            <div key={i} className="col-1">
              <div className="card contact-card">
                <h2>{contact.profile.firstName} {contact.profile.lastName}</h2>
                {contact.status === "valid" &&
                  <div className="status">
                    <img src={validIcon} alt="mail" />
                  </div>
                }
                <button
                  type='button'
                  className='invit'
                  onClick={() => handleInvitUser(contact)}
                >
                  <img src={mail} alt="mail" />
                </button>
                <img className="star" src={contact.role === "Owner"? starActive : star} alt="star" />
                  {contact.profile.function ? <div className="text-primary" >{contact.profile.function}</div> : null }
                <p className="email">{contact.email}</p>
                <p className="email">{contact.profile?.phone}</p>
                <div className="information-container">
                  {renderPresenceDays(contact)}
                </div>
              </div>
            </div>
          )
        })} 
      </div>
    </>
  )
}
